// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    TestCase,
    TestCaseFromJSON,
    TestCaseToJSON,
    TestCaseRevision,
    TestCaseRevisionFromJSON,
    TestCaseRevisionToJSON,
    TestPlanMinified,
    TestPlanMinifiedFromJSON,
    TestPlanMinifiedToJSON,
    TestPlanTestCaseMinified,
    TestPlanTestCaseMinifiedFromJSON,
    TestPlanTestCaseMinifiedToJSON,
    User,
    UserFromJSON,
    UserToJSON,
} from './';

/**
 * 
 * @export
 * @interface Defect
 */
export interface Defect {
    /**
     * 
     * @type {number}
     * @memberof Defect
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof Defect
     */
    project: number;
    /**
     * 
     * @type {string}
     * @memberof Defect
     */
    externalId: string;
    /**
     * 
     * @type {string}
     * @memberof Defect
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Defect
     */
    userComment?: string;
    /**
     * 
     * @type {string}
     * @memberof Defect
     */
    defectUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof Defect
     */
    defectStatus?: string;
    /**
     * 
     * @type {TestCase}
     * @memberof Defect
     */
    testcase?: TestCase;
    /**
     * 
     * @type {TestPlanMinified}
     * @memberof Defect
     */
    testplan?: TestPlanMinified;
    /**
     * 
     * @type {TestCaseRevision}
     * @memberof Defect
     */
    testcaserevision?: TestCaseRevision;
    /**
     * 
     * @type {User}
     * @memberof Defect
     */
    createdBy?: User;
    /**
     * 
     * @type {User}
     * @memberof Defect
     */
    updatedBy?: User;
    /**
     * 
     * @type {string}
     * @memberof Defect
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof Defect
     */
    updatedAt?: string;
    /**
     * 
     * @type {TestPlanTestCaseMinified}
     * @memberof Defect
     */
    testplantestcase?: TestPlanTestCaseMinified;
    /**
     * 
     * @type {number}
     * @memberof Defect
     */
    stepNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof Defect
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof Defect
     */
    description?: string;
    /**
     * ID
     * @type {number}
     * @memberof Defect
     */
    executedtestcase?: number;
    /**
     * Stringified JSON object for configuration values as per AvailableIssueManager config fields
     * @type {string}
     * @memberof Defect
     */
    defectConfig?: string;
    /**
     * 
     * @type {string}
     * @memberof Defect
     */
    issueManager?: string;
}

export function DefectFromJSON(json: any): Defect {
    return {
        'id': json['id'],
        'project': json['project'],
        'externalId': json['external_id'],
        'title': json['title'],
        'userComment': !exists(json, 'user_comment') ? undefined : json['user_comment'],
        'defectUrl': !exists(json, 'defect_url') ? undefined : json['defect_url'],
        'defectStatus': !exists(json, 'defect_status') ? undefined : json['defect_status'],
        'testcase': !exists(json, 'testcase') ? undefined : TestCaseFromJSON(json['testcase']),
        'testplan': !exists(json, 'testplan') ? undefined : TestPlanMinifiedFromJSON(json['testplan']),
        'testcaserevision': !exists(json, 'testcaserevision') ? undefined : TestCaseRevisionFromJSON(json['testcaserevision']),
        'createdBy': !exists(json, 'created_by') ? undefined : UserFromJSON(json['created_by']),
        'updatedBy': !exists(json, 'updated_by') ? undefined : UserFromJSON(json['updated_by']),
        'createdAt': json['created_at'],
        'updatedAt': !exists(json, 'updated_at') ? undefined : json['updated_at'],
        'testplantestcase': !exists(json, 'testplantestcase') ? undefined : TestPlanTestCaseMinifiedFromJSON(json['testplantestcase']),
        'stepNumber': !exists(json, 'step_number') ? undefined : json['step_number'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'executedtestcase': !exists(json, 'executedtestcase') ? undefined : json['executedtestcase'],
        'defectConfig': !exists(json, 'defect_config') ? undefined : json['defect_config'],
        'issueManager': !exists(json, 'issue_manager') ? undefined : json['issue_manager'],
    };
}

export function DefectToJSON(value?: Defect): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'project': value.project,
        'external_id': value.externalId,
        'title': value.title,
        'user_comment': value.userComment,
        'defect_url': value.defectUrl,
        'defect_status': value.defectStatus,
        'testcase': TestCaseToJSON(value.testcase),
        'testplan': TestPlanMinifiedToJSON(value.testplan),
        'testcaserevision': TestCaseRevisionToJSON(value.testcaserevision),
        'created_by': UserToJSON(value.createdBy),
        'updated_by': UserToJSON(value.updatedBy),
        'created_at': value.createdAt,
        'updated_at': value.updatedAt,
        'testplantestcase': TestPlanTestCaseMinifiedToJSON(value.testplantestcase),
        'step_number': value.stepNumber,
        'status': value.status,
        'description': value.description,
        'executedtestcase': value.executedtestcase,
        'defect_config': value.defectConfig,
        'issue_manager': value.issueManager,
    };
}


